'use strict';

angular.module('TurneroApp').component('coTurnoOrdendellegadaImprimir', {
	bindings: {
		datosEquipo: '<',
		centroAtencionSeleccionado: '<'
	},
	controller: [
		 'turnosService',
		 '$anchorScroll',
		 '$stateParams',
		 '$window',
		 'utilsService',
		 'TurneroAppConstant',
		 'llamadorService',
		 function (turnosService, $anchorScroll, $stateParams, $window, utilsService, TurneroAppConstant, llamadorService) {
		 	var ctrl = this;
		 	ctrl.Date = new Date();
		 	ctrl.limpiarMemoria = function () {
		 		ctrl.reimprimir = {};
		 	}

		 	ctrl.obtenerDatosReimpresion = function (id_turno) {
		 		llamadorService.Configuracion_Llamador({ 'id_centro_atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (data) {
		 			ctrl.llamadorConfig = data;
		 			turnosService.Get_Ticket({ 'id_turno': parseInt(id_turno) }).$promise.then(function (data) {
		 				ctrl.datosTicket = data.Data;
		 				ctrl.didInsertElement();
		 				$anchorScroll();
		 			}).catch(function (error) {
		 				utilsService.errores(error);
		 			});
		 		}).catch(function (error) {
		 			utilsService.errores(error);
		 		});
		 	};
		 	ctrl.$onChanges = function () {
		 		if (ctrl.datosEquipo) {
		 			ctrl.obtenerDatosReimpresion(ctrl.datosEquipo.Id_Turno);
		 		}
		 	}

		 	ctrl.tagName = "canvas";
		 	ctrl.attributeBindings = ["width", "height"];
		 	ctrl.cmWidth = 7;
		 	ctrl.cmHeight = 9.83;
		 	ctrl.dpi = 300;

		 	ctrl.logoParticular = null,
			ctrl.plantillaTicket = "assets/img/ticket-template.png";

		 	ctrl.cmToPx = function (cm) {
		 		return ctrl.dpi * cm / 2.54
		 	};

		 	ctrl.width = ctrl.cmToPx(ctrl.cmWidth);
		 	ctrl.height = ctrl.cmToPx(ctrl.cmHeight);
		 	ctrl.ctx = document.getElementById('ticketCanvas').getContext("2d");

		 	ctrl.didInsertElement = function () {
		 		if (ctrl.datosTicket !== null) ctrl.generar();
		 	},

			ctrl.datosTicket = null,

			ctrl.datosTicketChanged = function () {
				if (ctrl.datosTicket !== null) ctrl.generar();
			};

		 	ctrl.textoAjustado = function (texto, anchoMaximo, cssFuente) {
		 		var ctx = ctrl.ctx;
		 		var textoAjustado = "";
		 		var caracter = "";
		 		var num;
		 		var resultado = [];

		 		if (cssFuente) ctx.font = cssFuente;

		 		for (var i = 0; i < texto.length; i++) {
		 			caracter = texto[i];
		 			textoAjustado += caracter;
		 			if (ctx.measureText(textoAjustado).width > (anchoMaximo || ctrl.width)) {
		 				num = 0;
		 				for (; caracter.charCodeAt(0) != 32; caracter = texto[i]) {
		 					++num;
		 					--i;
		 				}
		 				resultado.push(textoAjustado.substr(0, textoAjustado.length - num));
		 				textoAjustado = "";
		 			}
		 		}

		 		resultado.push(texto.replace(resultado.join(""), ""));

		 		return resultado;
		 	};

		 	ctrl.dibujarLinea = function dibujarLinea(x1, y1, x2, y2) {
		 		var ctx = ctrl.ctx;
		 		ctx.beginPath();
		 		ctx.moveTo(x1, y1);
		 		ctx.lineTo(x2, y2);
		 		ctx.stroke();
		 	};

		 	ctrl.imprimir = function (mantenerFoco) {
		 		var img = new Image();
		 		var ctx = ctrl.ctx;
		 		var p = window.open("", "printTicket", "");
		 		img.src = ctx.canvas.toDataURL();
		 		img.style.width = ctrl.cmWidth + "cm";
		 		p.document.body.appendChild(img);
		 		img.onload = function () {
		 			p.print(); p.close();
		 		};
		 	};

		 	ctrl.generar = function () {
		 		var ctrl = this;
		 		var ctx = ctrl.ctx;
		 		ctx.canvas.style.position = "absolute";
		 		ctx.canvas.style.left = "-10000px";
		 		var datosTicket = ctrl.datosTicket;

		 		var ticket = new Image();
		 		ticket.src = ctrl.plantillaTicket;
		 		ticket.onload = function () {
		 			var nextY = 1.75;
		 			ctx.drawImage(ticket, 0, 0);
		 			ctx.lineWidth = 5;

		 			ctx.font = "bold 0.5cm sans-serif";
		 			ctx.fillText("FECHA Y HORA DEL TURNO", ctrl.cmToPx(0.15), ctrl.cmToPx(nextY));

		 			nextY += 0.15;

		 			ctrl.dibujarLinea(ctrl.cmToPx(0.15), ctrl.cmToPx(nextY), ctrl.cmToPx(6.85), ctrl.cmToPx(nextY));

		 			nextY += 0.4;

		 			ctx.font = "bold 1cm \"Arial Narrow\"";
		 			ctx.fillText(moment().format("DD/MM/YYYY HH:mm"), ctrl.cmToPx(0.15), ctrl.cmToPx(nextY));

		 			ctx.font = "bold 0.5cm sans-serif";
		 			ctx.fillText("CENTRO DE ATENCIÓN", ctrl.cmToPx(2.75), ctrl.cmToPx(nextY - 0.55));

		 			ctx.font = "bold 1cm \"Arial Narrow\"";
		 			var lineasCentroAtencion = ctrl.textoAjustado(datosTicket.Turno.N_Centro_Atencion, ctrl.cmToPx(3.75));
		 			lineasCentroAtencion.forEach(function (linea, nro) {
		 				nextY += nro * 0.35;
		 				ctx.fillText(linea, ctrl.cmToPx(2.75), ctrl.cmToPx(nextY));
		 			});

		 			nextY += 0.4;

		 			ctx.font = "bold 0.5cm sans-serif";
		 			ctx.fillText("INTERESADO", ctrl.cmToPx(0.15), ctrl.cmToPx(nextY));

		 			nextY += 0.15;

		 			ctrl.dibujarLinea(ctrl.cmToPx(0.15), ctrl.cmToPx(nextY), ctrl.cmToPx(6.85), ctrl.cmToPx(nextY));

		 			nextY += 0.4;

		 			ctx.font = "bold 1cm \"Arial Narrow\"";
                        var identificador = datosTicket.Turno.N_Usuario_Cidi || datosTicket.Turno.Nro_Documento || '';
                        var Interesado = ctrl.llamadorConfig && ctrl.llamadorConfig.grupoIdentificador.toUpperCase() == 'DNI' ? identificador : datosTicket.Turno.Nombre + (identificador ? " (" + identificador + ")" : "");
		 			var lineasInteresado = ctrl.textoAjustado(Interesado, ctrl.cmToPx(6.85));
		 			lineasInteresado.forEach(function (linea, nro) {
		 				nextY += nro * 0.35;
		 				ctx.fillText(linea, ctrl.cmToPx(0.15), ctrl.cmToPx(nextY));
		 			});

		 			nextY += 0.4;

		 			ctx.font = "bold 0.5cm sans-serif";
		 			ctx.fillText("TRÁMITE", ctrl.cmToPx(0.15), ctrl.cmToPx(nextY));

		 			nextY += 0.15;

		 			ctrl.dibujarLinea(ctrl.cmToPx(0.15), ctrl.cmToPx(nextY), ctrl.cmToPx(6.85), ctrl.cmToPx(nextY));

		 			nextY += 0.4;

		 			ctx.font = "bold 1cm \"Arial Narrow\"";
		 			var lineasTramite = ctrl.textoAjustado(datosTicket.Turno.N_Tramite ? datosTicket.Turno.N_Tramite : datosTicket.Turno.N_Agenda, ctrl.cmToPx(6.85));
		 			var nrolineas = lineasTramite.length;
		 			lineasTramite.forEach(function (linea, nro) {

		 				if (nro > 1) {
		 					return;
		 				} else {
		 					nextY += nro * 0.35;
		 					linea = (nro == 1 && nrolineas > 2) ? (linea.substring(0, linea.length - 3) + '...') : linea;
		 					ctx.fillText(linea, ctrl.cmToPx(0.15), ctrl.cmToPx(nextY));
		 				}

		 			});

		 			//	nextY += 0.4;

		 			//ctx.font = "bold 0.5cm sans-serif";
		 			//ctx.fillText("AGENDA", ctrl.cmToPx(0.15), ctrl.cmToPx(nextY));

		 			//nextY += 0.15;

		 			//ctrl.dibujarLinea(ctrl.cmToPx(0.15), ctrl.cmToPx(nextY), ctrl.cmToPx(6.85), ctrl.cmToPx(nextY));

		 			nextY += 0.4;

		 			//ctx.font = "bold 1cm \"Arial Narrow\"";
		 			//var lineasAgenda = ctrl.textoAjustado(datosTicket.Turno.N_Agenda, ctrl.cmToPx(6.85));
		 			//lineasAgenda.forEach(function (linea, nro) {
		 			//    nextY += nro * 0.35;
		 			//    ctx.fillText(linea, ctrl.cmToPx(0.15), ctrl.cmToPx(nextY));
		 			//});

		 			nextY += 1;

		 			ctx.font = "bold 0.75cm sans-serif";
		 			ctx.fillText("USTED SERÁ LLAMADO CON EL Nº", ctrl.cmToPx(2.35), ctrl.cmToPx(nextY - 0.5));

		 			ctx.font = "bold 3.5cm sans-serif";
		 			ctx.rect(ctrl.cmToPx(2.25), ctrl.cmToPx(nextY - 0.35), ctrl.cmToPx(4.6), ctrl.cmToPx(1));
		 			ctx.stroke();
		 			ctx.fillText(datosTicket.Turno.Nro_Ticket, ctrl.cmToPx(2.35), ctrl.cmToPx(nextY + 0.55));

		 			ctx.font = "bold 0.75cm \"Arial Narrow\"";
		 			ctx.fillText("ATENCIÓN POR ORDEN DE LLEGADA", ctrl.cmToPx(2.35), ctrl.cmToPx(nextY + 1));
		 			ctx.font = "0.75cm \"Arial Narrow\"";
		 			ctx.fillText("T:" + datosTicket.Turno.Id_Turno + " O:" + ctrl.datosEquipo.Modulo + (ctrl.datosEquipo.N_Equipo ? (" K: CA" + ctrl.datosEquipo.N_Equipo) : ""), ctrl.cmToPx(2.35), ctrl.cmToPx(nextY + 1.25));

		 			if (datosTicket.Turno.Id_Prioridad == TurneroAppConstant.Prioridades.Muy_Alta && datosTicket.Turno.Sujeto_Ley_9131 == 'S') {
		 				ctx.font = "bold 1cm sans-serif";
		 				ctx.fillText("PRIORIDAD / LEY Nº 9.131", ctrl.cmToPx(2.35), ctrl.cmToPx(nextY + 1.75));
		 			}

		 			if (datosTicket.Turno.Tiempo_Espera) {
		 				ctx.font = "1cm sans-serif";
		 				ctx.fillText("Tiempo de espera aproximado: " + datosTicket.Turno.Tiempo_Espera + 'min/s', ctrl.cmToPx(3), ctrl.cmToPx(nextY + 5));
		 			}

		 			//if (datosTicket.autoimprimir) 
		 			ctrl.imprimir(datosTicket);
		 		};
		 	}



		 }
	],
	template: require('./turnoOrderDeLlegada_Comprobante.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnoOrderDeLlegada_ComprobanteComponent.js